import { useQuery } from 'react-query';
import { getAuthenticatedApiClient } from '../api-client';

const getFerryText = () =>
  getAuthenticatedApiClient()
    .getGenericPageBySlug({ slug: 'ferry-info' })
    .then((x) => x.data);

export const useGetFerryText = () => useQuery('ferry-text', () => getFerryText());
